import { Component } from 'react';
import dynamic from 'next/dynamic';
const s = require('../../components/LoadMore/Load.module.scss');

const Post = dynamic(() => import('../../components/Post'));
const LoadMore = dynamic(() => import('../../components/LoadMore'));

export async function getServerSideProps({ query }) {
  const id = query.id;
  const page = query.page;
  const param = page ? page : id;
  const previewParam = query.preview_id
    ? `?preview_id=${query.preview_id}`
    : null; // If it's a preview url it should still work
  let data;

  const pages = await fetch(
    `${process.env.NEXT_PUBLIC_API_PROTO}://${
      process.env.NEXT_PUBLIC_API_HOST
    }:${process.env.NEXT_PUBLIC_API_PORT}/api/${
      process.env.NEXT_PUBLIC_API_VERSION
    }/post/${param}${previewParam || ''}`
  );
  data = await pages.json();
  return {
    props: {
      pages: data,
      query: param,
    },
  };
}

class ArticlePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentArticles: [this.props],
    };
  }

  render() {
    return (
      <>
        <div>
          {this.state.currentArticles.length > 0 &&
            this.state.currentArticles.map((item, index) => (
              <div key={index} id={item.query}>
                <Post data={item.pages} router={this.props.router} />
              </div>
            ))}

          {this.props.pages.next && (
            <div className={s.LoadMore}>
              <a href={this.props.pages.next}>Next Article</a>
            </div>
          )}
          <div id='view' />
        </div>
      </>
    );
  }
}

export default ArticlePage;
